module.exports = __webpack_public_path__ + "img/vip2.1d553a3c.png";